import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TypeFormWidget: WidgetRegistryEntry = {
  name: "TypeForm",
  component: () => import("./type-form-widget.component").then((m) => m.TypeFormWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.TypeFormWidgetConfiguration)
};
